import { inject, Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Pipe({
  name: 'bypassHtmlSanitizer',
  standalone: true,
})
export class BypassHtmlSanitizerPipe implements PipeTransform {
  protected sanitizer = inject(DomSanitizer)

  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value)
  }
}
